import { NgModule } from '@angular/core';
import { PsI18nPipe } from './psi18n.pipe';

@NgModule({
  declarations: [PsI18nPipe],
  exports: [PsI18nPipe]
})
export class PsI18nModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.core/i18n/psi18n.module.ts